import React, { createContext, useState, ReactNode, useCallback } from 'react';
import SharedConfirmationDialog from '../ConfirmationDialog';
import { registerDialogApi } from './DialogApi';
import { ConfirmationDialogProps } from './ConfirmationDialogProps';
import { Theme } from '@mui/material/styles';

const DialogContext = createContext<(props: any) => Promise<boolean>>(() => Promise.resolve(false));

export function DialogProvider({ children, mainTheme }: { children: ReactNode; mainTheme: Partial<Theme> }) {
	const [dialogProps, setDialogProps] = useState<Partial<ConfirmationDialogProps> | null>(null);

	const displayDialog = useCallback((props: any) => {
		return new Promise<boolean>(resolve => {
			setDialogProps({
				...props,
				open: true,
				onClose: (result: boolean) => {
					resolve(result);
					setDialogProps(null);
				}
			});
		});
	}, []);

	React.useEffect(() => {
		registerDialogApi({ displayDialog });
		return () => registerDialogApi(null);
	}, [displayDialog]);

	return (
		<DialogContext.Provider value={displayDialog}>
			{children}
			{dialogProps && <SharedConfirmationDialog mainTheme={mainTheme} {...dialogProps} />}
		</DialogContext.Provider>
	);
}
